import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { KomodoCoreWrappersModule } from '@komodo-design-system/komodo-core-angular-twelve-wrappers/dist/komodo-core-wrappers';
import { KwaAngular18Module } from '@komodo-design-system/komodo-kwa-angular-18';
import { GanttChartModule } from 'smart-webcomponents-angular/ganttchart';

import { SharedModule } from '../../shared.module';
import { KpisComponent } from './components/kpis/kpis.component';
import { KpiChartsSidePanelModule } from './components/panels/kpi-charts-side-panel/kpi-charts-side-panel.module';
import { StudyGanttChartModule } from './components/study-gantt-chart/study-gantt-chart.module';
import { StudyDetailsComponent } from './study-details.component';

@NgModule({
  declarations: [StudyDetailsComponent, KpisComponent],
  exports: [StudyDetailsComponent],
  imports: [
    BrowserModule,
    GanttChartModule,
    KwaAngular18Module,
    KomodoCoreWrappersModule,
    SharedModule,
    KpiChartsSidePanelModule,
    StudyGanttChartModule
  ]
})
export class StudyDetailsModule {}
